import type { FilterOption, Options } from '@ckprivate/ckf-ui';

import { getPersistedObject, persistData } from './localStorage';

const HFW_USER_PREFERENCES_KEY = 'hfwup';

type SortOption = NonNullable<Options['sort']>;

export function getSort({
  componentName,
  sort,
  sortableAccessors,
}: {
  componentName: string;
  sort: SortOption;
  sortableAccessors: string[];
}): SortOption {
  const userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const persisted: SortOption | undefined =
    userPreferences?.[`${componentName}.sort`];

  // La colonne persistée peut avoir disparu depuis (renommage, colonne retirée)
  if (!persisted || !sortableAccessors.includes(persisted.columnAccessor)) {
    return sort;
  }

  return persisted;
}

export function saveSort({
  componentName,
  sort,
}: {
  componentName: string;
  sort: SortOption;
}): void {
  let userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const preferencesKey = `${componentName}.sort`;
  if (!userPreferences) userPreferences = {};
  userPreferences[preferencesKey] = sort;
  persistData(HFW_USER_PREFERENCES_KEY, userPreferences);
}

export function getFilter({
  componentName,
  filter,
}: {
  componentName: string;
  filter: FilterOption[];
}): FilterOption[] {
  let userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const preferencesKey = `${componentName}.filter`;
  if (!userPreferences || !userPreferences[preferencesKey]) {
    userPreferences = {
      [preferencesKey]: filter,
    };
  }

  const result = [...userPreferences[preferencesKey]];

  result.forEach((item: FilterOption, index: number) => {
    if (filter?.[index]?.choices) {
      item.choices = filter[index].choices;
    }
  });

  return result;
}

export function saveFilter({
  componentName,
  filter,
}: {
  componentName: string;
  filter: FilterOption[];
}): void {
  let userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const preferencesKey = `${componentName}.filter`;
  if (!userPreferences) userPreferences = {};
  userPreferences[preferencesKey] = filter;
  persistData(HFW_USER_PREFERENCES_KEY, userPreferences);
}

export function getHiddenColumns({
  componentName,
  hiddenColumns = [],
}: {
  componentName: string;
  hiddenColumns?: string[];
}): string[] {
  let userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const preferencesKey = `${componentName}.hiddenColumns`;
  if (!userPreferences || !userPreferences[preferencesKey]) {
    userPreferences = {
      [preferencesKey]: hiddenColumns,
    };
  }
  return userPreferences[preferencesKey];
}

export function saveHiddenColumns({
  componentName,
  hiddenColumns,
}: {
  componentName: string;
  hiddenColumns: string[];
}): void {
  let userPreferences = getPersistedObject(HFW_USER_PREFERENCES_KEY);
  const preferencesKey = `${componentName}.hiddenColumns`;
  if (!userPreferences) userPreferences = {};
  userPreferences[preferencesKey] = hiddenColumns;
  persistData(HFW_USER_PREFERENCES_KEY, userPreferences);
}
